import React, { Component } from 'react'
import PropTypes from 'prop-types'

// CSS
import './Categories.css'

class Categories extends Component {

    static propTypes = {
        categories: PropTypes.array.isRequired,
        selectedCategory: PropTypes.string,
        onSelectCategory: PropTypes.func.isRequired
    }

    render() {

        const selectedCategory =  this.props.selectedCategory ? this.props.selectedCategory : 'all'

        return (
            <ul className={"categories"}>
                <li key={"all"} onClick={() => this.props.onSelectCategory(null)} className={`category all ${selectedCategory === 'all' ? 'active' : ''}`}>All</li>
                {this.props.categories.map(category => {
                    return <li key={category} onClick={() => this.props.onSelectCategory(category)} className={`category ${category} ${selectedCategory === category ? 'active' : ''}`}>{category}</li>
                })}
            </ul>
        )
    }
}

export default Categories;





// WEBPACK FOOTER //
// ./src/components/main/work/categories/Categories.js